import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography';
import red from '@material-ui/core/colors/red';
import { TextField, PasswordField, Button, LoadingIndicator, NavigationLink, AppBar } from '../components';
import { ThemeImages, ThemeColors } from '../theme';
import Config from '../../run-config';
import oevs_logo from '../../images/customerexpert/logo_oevs.png';
class Login extends Component {

  constructor(props) {
    super(props);
    this.state = {
      userName: '',
      password: '',
    };

    this.setUsername = this.setUsername.bind(this);
    this.setPassword = this.setPassword.bind(this);
    this.keyPress = this.keyPress.bind(this);
    this.login = this.login.bind(this);
  }

  get brandSettings() {
    if (this.props.brand == 'oevs') {
      return {
        color: '#009EE3',
        logo: oevs_logo,
        name: 'ÖVS Star',
        signupRoute: 'signup-oevs',
        forgotPassswordRoute: 'forgotpassword-oevs',
        impressUrl: 'https://www.oevs-star.at/wp-content/uploads/2022/01/AGB_OeVS-Star.pdf',
      };
    }

    return {};
  }

  setUsername(event) {
    this.setState({ userName: event.target.value });
  }

  setPassword(event) {
    this.setState({ password: event.target.value });
  }

  keyPress(event) {
    if (event.key === 'Enter') {
      this.login();
      event.preventDefault();
      return false;
    }
    return true;
  }

  login() {
    if (this.state.userName && this.state.userName !== '' && this.state.password && this.state.password !== '') {
      this.props.login({ userName: this.state.userName, password: this.state.password });
    }
  }

  render() {
    const formGroupStyle = {
      // width: '100%',
      textAlign: 'center',
      margin: '0 20px',
    };

    const containerStyle = {
      width: '300px',
      margin: '0 auto',
      backgroundColor: 'rgba(255, 255, 255, 0.8)',
      marginTop: 'calc(50vh - 300px)',
      boxShadow: '-10px 16px 40px rgba(93,87,87,.14)',
    };

    const errorContainerStyle = {
      backgroundColor: red[500],
      textAlign: 'center',
      color: 'white',
    };

    const ErrorMessage = (props) => {
      if (!props.errorMessage) {
        return null;
      }

      return (
        <div style={errorContainerStyle}>
          <span>{props.errorMessage}</span>
        </div>
      );
    };

    const LoginButton = (props) => {
      if (props.loading) {
        return <LoadingIndicator style={{ color: this.brandSettings.color }}/>;
      }

      return (<Button
        label="Einloggen"
        labelStyle={{ color: ThemeColors.darkTextOnPrimaryBackground ? 'black' : 'white' }}
        onClick={this.login}
        style={{ width: '100%', backgroundColor: this.brandSettings.color }}
        color="primary"
        variant="contained"
      />);
    };

    const companySignup = Config.forbidCompanySignup ? null : (<div>
      <span style={{ marginRight: 10 }}>Für Unternehmen:</span>
      <NavigationLink to="benutzerregistrierung">Benutzer registrieren</NavigationLink>
      <br />
    </div>);

    const signupButton = !Config.forbidSignup
    ? (<div>
      <span style={{ marginRight: 10 }}>Noch kein Account?</span>
      <NavigationLink to={this.brandSettings.signupRoute || 'signup'}>Jetzt registrieren</NavigationLink>
      <br />
      {companySignup}
    </div>)
    : null;

    return (
      <form style={containerStyle} onKeyPress={this.keyPress} noValidate>
        <div style={{ padding: 20 }}>
          <img src={this.brandSettings.logo || ThemeImages.logoPath} alt="Einrichtungsberater App Logo" style={{ width: '100%' }} />
        </div>
        <AppBar
          title="Login"
          defaultTypography
          backgroundColor={this.brandSettings.color}
        />

        <ErrorMessage {...this.props} />
        <div
          style={{
            ...formGroupStyle,
            marginTop: 10,
          }}
        >
          <TextField
            autoFocus
            required
            placeholder="E-Mail"
            value={this.state.userName}
            onChange={this.setUsername}
          />
        </div>
        <div style={formGroupStyle}>
          <PasswordField
            required
            hintText="Passwort"
            value={this.state.password}
            onChange={this.setPassword}
          />
        </div>
        <div
          style={{
            // ...formGroupStyle,
            marginTop: 20,
            paddingBottom: 10,
          }}
        >
          <LoginButton {...this.props} />
        </div>
        <div
          style={{
            ...formGroupStyle,
            marginTop: 20,
            paddingBottom: 10,
          }}
        >
          {signupButton}

          <br />
          <NavigationLink to={this.brandSettings.forgotPassswordRoute || 'forgotpassword'}>Passwort vergessen?</NavigationLink>
        </div>
      </form>
    );
  }
}

Login.propTypes = {
  login: PropTypes.func.isRequired,
};

export default Login;



// WEBPACK FOOTER //
// ./src/app/login/login.js